// editor.service.ts
import { Injectable } from '@angular/core';
import { BlockSettings } from '@app/core/models';
import { LocalStorageService } from '@shared/services/storage';

/** Co emitujemy do świata */
export interface EditEvent {
  html: string; // wyczyszczony html
  element: HTMLElement;
}

@Injectable({ providedIn: 'root' })
export class EditorService {
  private closeActiveEditor: (() => void) | null = null;
  clickButton: boolean;
  pageTitle: any;
  pageDesc: any;

  selectTopBar: 'classic' | 'slider';

  settingsSlider: BlockSettings;

  pageBlock;

  private finishCallbacks = new Set<() => void>();

  constructor(private localStorageService: LocalStorageService) {}

  isEditModeEnabled(): boolean {
    const hasEditInUrl = window.location.hash === '#edit';
    // tryb edycji włączamy tylko dla użytkownika posiadającego token.
    //  const hasToken = !!this.localStorageService.getItem('adminAuthToken');
    return hasEditInUrl; //&& hasToken;
  }

  isBlock(ev: MouseEvent): boolean {
    const next = ev?.relatedTarget as HTMLElement | null;
    if (!next) return false;
    return !!next.closest('[data-editor-toolbar]');
  }

  /** zapamiętujemy callback zamykania aktualnego edytora */
  register(closeFn: () => void): void {
    // jeśli jakiś edytor już działa – zwiń go
    this.closeActiveEditor?.();
    this.closeActiveEditor = closeFn;
  }

  /** usuwa referencję, gdy edytor sam się zamknie */
  unregister(closeFn: () => void): void {
    if (this.closeActiveEditor === closeFn) {
      this.closeActiveEditor = null;
    }
  }

  closeAll() {
    this.finishCallbacks.forEach((callback) => callback());
    this.finishCallbacks.clear();
  }
}
